import { render, staticRenderFns } from "./my-header.vue?vue&type=template&id=cd2b9b54&scoped=true"
import script from "./my-header.vue?vue&type=script&lang=js"
export * from "./my-header.vue?vue&type=script&lang=js"
import style0 from "./my-header.vue?vue&type=style&index=0&id=cd2b9b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2b9b54",
  null
  
)

export default component.exports